import { User } from 'lucide-react-native';
import { memo } from 'react';
import { View } from 'react-native';
import { aiColors } from '../../../../../ai-suite/theme';

/** The customer's round avatar. */
export const CustomerAvatar = memo(({ size }: { size: number }) => (
  <View
    style={{
      width: size,
      height: size,
      borderRadius: size / 2,
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: aiColors.secondary,
    }}
  >
    <User size={size / 2} color={aiColors.primary} />
  </View>
));
